module.exports = __webpack_public_path__ + "web/img/login-logo.ca4bbc5f.png";